export const AUTH_ROUTES = {
  login: '/login',
  unauthorized: '/unauthorized',
  resetPassword: '/reset-password',
  external: '/external',
} as const;
